import { nanoid } from "nanoid";
export async function ReferenceGenerator() {
  const uniqueCode = `SUPRE_${nanoid(26)}`;
  return uniqueCode;
}
